<template>
  <div class="w100 Contenido">

    <Titulo seccion="Registro Pluviométrico Mensual" icon="cloud-showers-heavy"/>
    <Descripcion>Consiste en el registro mensual de la precipitación acumulada a lo largo del ciclo de cultivo.</Descripcion>
    <Tabla nombre="Pluviometros" :columnas="columnasTabla"/>
    <BotonVerMapa route="/vermapa?t=1" />
  </div>
</template>

<script>
import { ColumnasTabla } from '../../Auxiliares/Enums';

export default {
  name: "Pluviometros",
  data() {
    return {
      columnasTabla: [ ColumnasTabla.Productor, ColumnasTabla.Establecimiento, ColumnasTabla.Localidad ]
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../Css/Secciones/Tabla.css";
</style>
